import React from "react";
import Accordion from "react-bootstrap/Accordion";
import SectionTitle from "../../elements/section-title/SectionTitle";
import FaqOneChildren from "./FaqOneChildren";

const FaqOne = () => {
  return (
    <div className="section section-padding-equal bg-color-light faq-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-5 col-xl-4">
            <SectionTitle
              subtitle="Foire aux questions"
              title="Questions fréquentes sur la sous-location professionnelle"
              description=""
              textAlignment="heading-left"
              textColor=""
            />
          </div>
          <div className="col-lg-7 col-xl-8">
            <div className="faq-accordion">
              <Accordion defaultActiveKey="1">
                <FaqOneChildren
                  title="❓ Qu’est-ce que la sous-location professionnelle ?"
                  eventKey={1}
                  key={1}
                >
                  <p>
                    La sous-location professionnelle consiste à louer votre logement à une société 
                    (comme LocaJoy) qui devient votre locataire principal. Nous signons un bail 
                    professionnel puis relouons le bien à des locataires sélectionnés. Vous percevez 
                    un loyer mensuel fixe établi lors de la signature, sans frais de gestion.
                  </p>
                </FaqOneChildren>

                <FaqOneChildren
                  title="🔒 Le bail est-il légal et sécurisé ?"
                  eventKey={2}
                  key={2}
                >
                  <p>
                    Oui. Le bail professionnel est conclu avec votre accord et garantit un loyer 
                    mensuel fixe ainsi qu’une flexibilité pour récupérer votre bien à tout moment. 
                    Cela encadre légalement la sous-location et vous protège contre les impayés.
                  </p>
                </FaqOneChildren>

                <FaqOneChildren
                  title="📈 Comment est calculé le loyer garanti ?"
                  eventKey={3}
                  key={3}
                >
                  <p>
                    Lors de la visite de votre logement, nous évaluons son potentiel (emplacement, 
                    surface, prestations). Le loyer est alors fixé et vous est versé chaque mois, 
                    même si le logement est vacant. Ce montant reste identique durant toute 
                    notre collaboration.
                  </p>
                </FaqOneChildren>

                <FaqOneChildren
                  title="👤 Qui sont les locataires ?"
                  eventKey={4}
                  key={4}
                >
                  <p>
                    Nos locataires sont principalement des salariés ou cadres en déplacement 
                    professionnel, des fournisseurs ou des voyageurs d’affaires ayant besoin d’un 
                    logement pour quelques jours ou quelques semaines. Nous sélectionnons 
                    rigoureusement chaque profil pour assurer le respect de votre logement.
                  </p>
                </FaqOneChildren>

                <FaqOneChildren
                  title="🔧 Que se passe-t-il en cas de dégâts ou de problèmes ?"
                  eventKey={5}
                  key={5}
                >
                  <p>
                    Nous gérons l’intégralité de votre bien, y compris le ménage et l’entretien 
                    quotidien. En cas de dégradation, notre assurance couvre votre 
                    logement et nous nous chargeons des réparations nécessaires.
                  </p>
                </FaqOneChildren>

                <FaqOneChildren
                  title="💼 Puis-je récupérer mon logement quand je le souhaite ?"
                  eventKey={6}
                  key={6}
                >
                  <p>
                    Oui. Notre modèle est flexible : vous pouvez récupérer votre bien à tout moment 
                    selon le délai de préavis prévu au contrat. Cette flexibilité fait partie de 
                    nos engagements principaux.
                  </p>
                </FaqOneChildren>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
      <ul className="shape-group-6 list-unstyled">
        <li className="shape shape-1">
          <img src={process.env.PUBLIC_URL + "/images/others/bubble-7.png"} alt="Bubble" />
        </li>
        <li className="shape shape-2">
          <img src={process.env.PUBLIC_URL + "/images/others/line-4.png"} alt="line" />
        </li>
        <li className="shape shape-4">
          <img src={process.env.PUBLIC_URL + "/images/others/poses-lady.png"} alt="Poses" />
        </li>
      </ul>
    </div>
  );
};

export default FaqOne;
